//#region src/assets/find-activation-code.svg
var find_activation_code_default = "" + new URL("find-activation-code-D6QRbJeJ.svg", import.meta.url).href;
//#endregion
export { find_activation_code_default as default };

//# sourceMappingURL=find-activation-code.js.map